import Icon from '../Icon';

export default function ChannelsCard() {
  return (
    <div className="mb-[24px] flex flex-col items-center justify-between gap-4 rounded-md bg-white p-4 text-center shadow-mdc-elevation-z9-3 outline outline-2 outline-[#25D366] phone:flex-row phone:text-left">
      <div className="flex items-center justify-center gap-x-4 text-ellipsis ">
        <img alt="Canaltech" width={57} height={57} src="https://img.canaltech.com.br/canaltech-icon.svg" />
        <div className="flex flex-col">
          <span className="text-sm font-semibold">O Canaltech está no WhatsApp!</span>
          <span className="text-xs font-light">Entre no canal e acompanhe notícias e dicas de tecnologia</span>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center tablet:flex-row tablet:justify-between desktop:flex-col largeDesktop:flex-row">
        <a className="canal-ct-wpp" href="https://canalte.ch/canaltech-no-whatsapp-site" target="_blank" title="WhatsApp Canaltech">
          <div className="flex w-[136px] items-center justify-center rounded-[80px] bg-[#25D366]  p-2 text-center text-xs text-white transition transition-all ease-in hover:bg-black">
            <Icon icon="mdi:whatsapp" fontSize="0.50rem" /> <span className="ml-2">WhatsApp</span>
          </div>
        </a>
      </div>
    </div>
  );
}
